import React from 'react';
import '../App.css';

import { Bars } from 'react-loader-spinner';
// import { Watch } from 'react-loader-spinner';
// import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import styled from 'styled-components';
// import AdHeader from '../components/AdHeader';
import Colours from './Colors';
import Text from './Text';

import {
//   AppContainer,
//   HeaderContainer,
  SectionContainer,
} from './ResponsiveLayout';

const loaderSize = 250;

const StyledDiv = styled.div`
  width: ${loaderSize}px;
  margin-top: 40%;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  color: ${Colours.DEMO_DARK_GRAY};
`;

/**
 * Spinner Component
 * Loading indicator with accessibility support for screen readers
 * Memoized to prevent unnecessary re-renders
 *
 * @component
 * @returns {React.ReactElement} Full-page loading spinner
 */
const Spinner = React.memo(() => {
  return (
    <div className='spinner' role="progressbar" aria-busy="true" aria-live="polite">
         <section id="page">
            <header role="banner">

            </header>

            <main role="main" aria-label="Loading content">
            <SectionContainer>
                <StyledDiv>
                    <Bars
                      color={Colours.VIOLET_PURP}
                      height={loaderSize}
                      width={loaderSize}
                      aria-hidden="true"
                    />
                    <Text.Text aria-live="polite" aria-atomic="true">
                      Please wait ...
                    </Text.Text>
                    {/* Visually hidden text for screen readers */}
                    <span className="sr-only">Loading, please wait. This may take a few moments.</span>
                </StyledDiv>
            </SectionContainer>
            </main>

            <nav role="navigation">

            </nav>
            <footer role="contentinfo">

            </footer>
            </section>
    </div>
  );
});

Spinner.displayName = 'Spinner';

export default Spinner;
